import { PROCESS_QUIZ_QUESTION_RESPONSE_PAYLOAD_FIELDS } from "lib/experience-api/fragments";

export const PROCESS_QUIZ_QUESTION_RESPONSE = `
  ${PROCESS_QUIZ_QUESTION_RESPONSE_PAYLOAD_FIELDS}
  mutation ProcessQuizQuestionResponse($input: ProcessQuizQuestionResponseInput!) {
    processQuizQuestionResponse(input: $input) {
      ...ProcessQuizQuestionResponsePayloadFields
    }
  }
`;
